import { render, staticRenderFns } from "./FooterTwoButton.vue?vue&type=template&id=70e5a8fb&scoped=true"
import script from "./FooterTwoButton.vue?vue&type=script&lang=js"
export * from "./FooterTwoButton.vue?vue&type=script&lang=js"
import style0 from "./FooterTwoButton.vue?vue&type=style&index=0&id=70e5a8fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e5a8fb",
  null
  
)

export default component.exports